// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"loading_ldsRing__RiY7r"};